export default {
  card: {
    title: 'Оплата картой',
    inputs: {
      number: {
        title: 'Номер карты',
        placeholder: 'Введите номер карты',
      },
      cvc: {
        title: 'CVC',
        placeholder: 'CVC',
      },
      expiry: {
        title: 'ММ/ГГ',
        placeholder: 'ММ/ГГ',
      },
    },
  },
  'driver-tips': {
    title: 'Спасибо за<br><span>поддержку водителей!</span>',
    description: '100% чаевых идут напрямую',
    remember: 'Пожалуйста, помните, что оставлять чаевые — это полностью ваше решение!',
    'confirmation-modal': {
      title: 'Пожалуйста, подтвердите:',
      description: 'Вы уверены, что хотите отправить чаевые в размере',
      error: 'Сумма чаевых должна быть от $2 до $40.',
      actions: {
        confirm: 'Подтвердить',
        cancel: 'Отмена',
      },
    },
  },
  'tips-amount': {
    other: 'Другая сумма',
  },
  'tips-component': {
    thanks: 'Спасибо! Ваши чаевые получены и точно сделают день водителя ярче.',
    more: 'Отправить ещё чаевые',
  },
  'tips-old': {
    title: 'Спасибо за<br><span>поддержку водителей!</span>',
    description: '100% чаевых идут напрямую',
    btn: 'Оплатить картой',
  },
}
